<template>
  <div>
    <filtro-prefeituras :modoVisualizacao="modoVisualizacao" @atualizarBusca="(filtro) => this.filtroNome =  filtro"
                        @viewGrid="modoVisualizacao = 'grid'" @viewList="modoVisualizacao = 'list'"></filtro-prefeituras>
    <prefeituras-tabela :itens="prefeituras" :modoVisualizacao="modoVisualizacao"
                        @atualizarOrgao="atualizarSituacaoIntegracao"/>
  </div>
</template>

<script>

import {actionTypes, localStorageKeys} from '@/commons/constants'
import PrefeiturasTabela from "@/views/integracoes/PrefeiturasTabela";
import FiltroPrefeituras from "@/views/integracoes/FiltroPrefeituras";

export default{
  name: 'IntegracaoIPM',
  components: {FiltroPrefeituras, PrefeiturasTabela},
  data(){
        return{
          filtroNome: '',
          modoVisualizacao: '',
        }
    },
    computed:{
      prefeituras() {
        let lista = []
        lista.push(...this.$store.state.orgaos)
        const unirNomeSigla = (orgao)=>{
          return `${orgao.nome} - ${orgao.sigla}`
        }
        return lista.filter(prefeitura => unirNomeSigla(prefeitura).toLowerCase().includes(this.filtroNome.toLowerCase()))
      },
    },
    methods:{
      async atualizarSituacaoIntegracao(prefeitura){
        await this.$store.dispatch(actionTypes.ATIVAR_INTEGRACAO_IPM,
            {
              orgaoId: prefeitura.id,
              ativa: prefeitura.integracaoIPMAtiva
            }
        )
        if(prefeitura.integracaoIPMAtiva){
          this.mostrarNotificacaoSucesso(`Ativação realizada com sucesso!`)
        }else{
          this.mostrarNotificacaoSucesso(`Desativação realizada com sucesso!`)
        }
      }
    },
    mounted(){
      if(localStorage.getItem(localStorageKeys.PREFERENCIAS.IPM_VIEW_MODE)){
        this.modoVisualizacao = localStorage.getItem(localStorageKeys.PREFERENCIAS.IPM_VIEW_MODE)
      }else{
        this.modoVisualizacao = 'grid'
      }
    },
    watch:{
      modoVisualizacao:{
        handler(valor){
          localStorage.setItem(localStorageKeys.PREFERENCIAS.IPM_VIEW_MODE, valor)
        }
      }
    }
}
</script>
<style lang="stylus">
</style>
